export default "__VITE_ASSET__BxYIVC8B__"